export enum GlobalStyles {
    SCREEN_HEIGHT = "$screenHeight",
    HEADER_FONT = "$FP_HEADER_FONT",
    BASE_FONT = "$FP_BASE_FONT",
    BASE_COLOUR = "$FP_BASE_COLOUR",
    ACCENT_COLOUR = "$FP_ACCENT_COLOUR",
    BACKGROUND_COLOUR = "$FP_BACKGROUND_COLOUR",
    DEFAULT_ICON_FILL = "$FP_DEFAULT_ICON_FILL",
    ACTIVE_ICON_FILL = "$FP_ACTIVE_ICON_FILL",
    BORDER_RADIUS = "$FP_BORDER_RADIUS",
    PROP_BORDER_RADIUS = "$FP_PROP_BORDER_RADIUS",
    BORDER_THICKNESS = "$FP_BORDER_THICKNESS",
    BUTTON_RADIUS = "$FP_BUTTON_RADIUS",
    DEFAULT_SHADOW = "$FP_DEFAULT_SHADOW",

    NAVIGATION_TEXT = "$FP_NAVIGATION_TEXT",
    NAVIGATION_BACKGROUND = "$FP_NAVIGATION_BACKGROUND",
    NAVIGATION_BUTTON_TEXT = "$FP_NAVIGATION_BUTTON_TEXT",
    NAVIGATION_ICON_FILL = "$FP_NAVIGATION_ICON_FILL",
    NAVIGATION_ICON_FILL_ACTIVE = "$FP_NAVIGATION_ICON_FILL_ACTIVE",

    SPLASH_BACKGROUND = "$FP_SPLASH_BACKGROUND",
    SPLASH_LOGO = "$FP_SPLASH_LOGO",

    LEADERBOARD_PLACE_BACKGROUND = "$FP_LEADERBOARD_PLACE_BACKGROUND",
    LEADERBOARD_PLACE_TEXT = "$FP_LEADERBOARD_PLACE_TEXT",
    LEADERBOARD_MY_PLACE_BACKGROUND = "$FP_LEADERBOARD_MY_PLACE_BACKGROUND",
    LEADERBOARD_MY_PLACE_TEXT = "$FP_LEADERBOARD_MY_PLACE_TEXT",
    LEADERBOARD_SCORE_TEXT = "$FP_LEADERBOARD_SCORE_TEXT",

    TIME_DESCRIPTOR = "$FP_TIME_DESCRIPTOR",
    TIME_DESCRIPTOR_TEXT = "$FP_TIME_DESCRIPTOR_TEXT",
    TIME_BACKGROUND = "$FP_TIME_BACKGROUND",
    TIME_TEXT = "$FP_TIME_TEXT",
    TIME_BORDER_RADIUS = "$FP_TIME_BORDER_RADIUS",

    GAME_CTA_TEXT = "$FP_GAME_CTA_TEXT",
    GAME_TITLE_TEXT = "$FP_GAME_TITLE_TEXT",
    GAME_DATE_TEXT = "$FP_GAME_DATE_TEXT",
    EDGE_GAME_TITLE_TEXT = "$FP_EDGE_GAME_TITLE_TEXT",
    EDGE_GAME_SUBTITLE_TEXT = "$FP_EDGE_GAME_SUBTITLE_TEXT",
    EDGE_GAME_TEXT = "$FP_EDGE_GAME_TEXT",

    CHECKBOX_BACKGROUND = "$FP_CHECKBOX_BACKGROUND",
    CHECKBOX_BORDER = "$FP_CHECKBOX_BORDER",
    CHECKBOX_CHECKED = "$FP_CHECKBOX_CHECKED",

    THANKS_TEXT = "$FP_THANKS_TEXT",
    SUBMITTED_CHECKMARK = "$FP_SUBMITTED_CHECKMARK",

    SUBMITTED_CTA_BACKGROUND = "$FP_SUBMITTED_CTA_BACKGROUND",

    BET_DISPLAY_BACKGROUND = "$FP_BET_DISPLAY_BACKGROUND",
    BET_DISPLAY_HEADER = "$FP_BET_DISPLAY_HEADER",
    BET_DISPLAY_AMOUNT = "$FP_BET_DISPLAY_AMOUNT",
    BET_DISPLAY_CTA_BACKGROUND = "$FP_BET_DISPLAY_CTA_BACKGROUND",

    CASH_BACKGROUND = "$FP_CASH_BACKGROUND",
    CASH_TEXT = "$FP_CASH_TEXT",
    CASH_SEPARATOR = "$FP_CASH_SEPARATOR",

    PROP_HEADER = "$FP_PROP_HEADER",
    PROP_HEADER_TEXT = "$FP_PROP_HEADER_TEXT",
    PROP_HEADER_DATE = "$FP_PROP_HEADER_DATE",
    PROP_BACKGROUND = "$FP_PROP_BACKGROUND",
    PROP_PICKEM_TEXT = "$FP_PROP_PICKEM_TEXT",
    PROP_SELECTED_BACKGROUND = "$FP_PROP_SELECTED_BACKGROUND",
    PROP_SELECTED = "$FP_PROP_SELECTED",
    PROP_SELECTED_ICON = "$FP_PROP_SELECTED_ICON",
    PROP_ICON = "$FP_PROP_ICON",
    PROP_TEXT = "$FP_PROP_TEXT",
    PROP_TEAM_TEXT = "$FP_PROP_TEAM_TEXT",
    PROP_SELECTED_TEXT = "$FP_PROP_SELECTED_TEXT",
    PROP_AT_TEXT = "$FP_PROP_AT_TEXT",
    AT_BOX_BACKGROUND = "$FP_AT_BOX_BACKGROUND",
    AT_BOX_BORDER = "$FP_AT_BOX_BORDER",
    GAME_CTA_BACKGROUND_COLOUR = "$FP_GAME_CTA_BACKGROUND_COLOUR",

    WINNING_PROP = "$FP_WINNING_PROP",
    WINNING_PROP_TEXT = "$FP_WINNING_PROP_TEXT",
    LOSING_PROP = "$FP_LOSING_PROP",
    LOSING_PROP_TEXT = "$FP_LOSING_PROP_TEXT",
    PICKED_BACKGROUND = "$FP_PICKED_BACKGROUND",
    PICKED_TEXT = "$FP_PICKED_TEXT",

    DISABLED_BUTTON = "$FP_DISABLED_BUTTON",
    DISABLED_TEXT = "$FP_DISABLED_TEXT",
    BASE_BUTTON_BACKGROUND = "$FP_BASE_BUTTON_BACKGROUND",
    BASE_BUTTON_TEXT = "$FP_BASE_BUTTON_TEXT",
    ACCENT_BUTTON_TEXT = "$FP_ACCENT_BUTTON_TEXT",
    ACCENT_BUTTON_COLOUR = "$FP_ACCENT_BUTTON_COLOUR",
    CTA_BUTTON_TEXT = "$FP_CTA_BUTTON_TEXT",
    CTA_BUTTON_COLOUR = "$FP_CTA_BUTTON_COLOUR",
    DEFAULT_NAVIGATION_BUTTON_BACKGROUND = "$FP_DEFAULT_NAVIGATION_BUTTON_BACKGROUND",

    DROPDOWN_BACKGROUND = "$FP_DROPDOWN_BACKGROUND",
    DROPDOWN_OPTIONS_BACKGROUND = "$FP_DROPDOWN_OPTIONS_BACKGROUND",
    DROPDOWN_BORDER_RADIUS = "$FP_DROPDOWN_BORDER_RADIUS",
    DROPDOWN_TEXT = "$FP_DROPDOWN_TEXT",

    TROPHY = "$FP_TROPHY",
    LOSS_TEXT = "$FP_LOSS_TEXT",
    WIN_TEXT = "$FP_WIN_TEXT",
    BORDER_COLOR = "$FP_BORDER_COLOR",

    HR_PLACE_TEXT = "$FP_HR_PLACE_TEXT",
    HR_PLACE_BACKGROUND = "$FP_HR_PLACE_BACKGROUND",
    HR_PLACE_BACKGROUND_ACTIVE = "$FP_HR_PLACE_BACKGROUND_ACTIVE",
    HR_PLACE_CARD_BORDER_RADIUS = "$FP_HR_PLACE_CARD_BORDER_RADIUS",

    HR_PLACEMENT_TEXT = "$FP_HR_PLACEMENT_TEXT",
    HR_PLACEMENT_BACKGROUND = "$FP_HR_PLACEMENT_BACKGROUND",
    HR_PLACEMENT_BORDER = "$FP_HR_PLACEMENT_BORDER",

    HR_HORSE_ONE_BACKGROUND = "$FP_HR_HORSE_ONE_BACKGROUND",
    HR_HORSE_ONE_TEXT = "$FP_HR_HORSE_ONE_TEXT",
    HR_HORSE_TWO_BACKGROUND = "$FP_HR_HORSE_TWO_BACKGROUND",
    HR_HORSE_TWO_TEXT = "$FP_HR_HORSE_TWO_TEXT",
    HR_HORSE_THREE_BACKGROUND = "$FP_HR_HORSE_THREE_BACKGROUND",
    HR_HORSE_THREE_TEXT = "$FP_HR_HORSE_THREE_TEXT",
    HR_HORSE_FOUR_BACKGROUND = "$FP_HR_HORSE_FOUR_BACKGROUND",
    HR_HORSE_FOUR_TEXT = "$FP_HR_HORSE_FOUR_TEXT",
    HR_HORSE_FIVE_BACKGROUND = "$FP_HR_HORSE_FIVE_BACKGROUND",
    HR_HORSE_FIVE_TEXT = "$FP_HR_HORSE_FIVE_TEXT",
    HR_HORSE_SIX_BACKGROUND = "$FP_HR_HORSE_SIX_BACKGROUND",
    HR_HORSE_SIX_TEXT = "$FP_HR_HORSE_SIX_TEXT",
    HR_HORSE_SEVEN_BACKGROUND = "$FP_HR_HORSE_SEVEN_BACKGROUND",
    HR_HORSE_SEVEN_TEXT = "$FP_HR_HORSE_SEVEN_TEXT",
    HR_HORSE_EIGHT_BACKGROUND = "$FP_HR_HORSE_EIGHT_BACKGROUND",
    HR_HORSE_EIGHT_TEXT = "$FP_HR_HORSE_EIGHT_TEXT",
    HR_HORSE_NINE_BACKGROUND = "$FP_HR_HORSE_NINE_BACKGROUND",
    HR_HORSE_NINE_TEXT = "$FP_HR_HORSE_NINE_TEXT",
    HR_HORSE_TEN_BACKGROUND = "$FP_HR_HORSE_TEN_BACKGROUND",
    HR_HORSE_TEN_TEXT = "$FP_HR_HORSE_TEN_TEXT",
    HR_HORSE_ELEVEN_BACKGROUND = "$FP_HR_HORSE_ELEVEN_BACKGROUND",
    HR_HORSE_ELEVEN_TEXT = "$FP_HR_HORSE_ELEVEN_TEXT",
    HR_HORSE_TWELVE_BACKGROUND = "$FP_HR_HORSE_TWELVE_BACKGROUND",
    HR_HORSE_TWELVE_TEXT = "$FP_HR_HORSE_TWELVE_TEXT",
    HR_HORSE_THIRTEEN_BACKGROUND = "$FP_HR_HORSE_THIRTEEN_BACKGROUND",
    HR_HORSE_THIRTEEN_TEXT = "$FP_HR_HORSE_THIRTEEN_TEXT",
    HR_HORSE_FOURTEEN_BACKGROUND = "$FP_HR_HORSE_FOURTEEN_BACKGROUND",
    HR_HORSE_FOURTEEN_TEXT = "$FP_HR_HORSE_FOURTEEN_TEXT",
    HR_HORSE_FIFTEEN_BACKGROUND = "$FP_HR_HORSE_FIFTEEN_BACKGROUND",
    HR_HORSE_FIFTEEN_TEXT = "$FP_HR_HORSE_FIFTEEN_TEXT",
    HR_HORSE_SIXTEEN_BACKGROUND = "$FP_HR_HORSE_SIXTEEN_BACKGROUND",
    HR_HORSE_SIXTEEN_TEXT = "$FP_HR_HORSE_SIXTEEN_TEXT",
    HR_HORSE_SEVENTEEN_BACKGROUND = "$FP_HR_HORSE_SEVENTEEN_BACKGROUND",
    HR_HORSE_SEVENTEEN_TEXT = "$FP_HR_HORSE_SEVENTEEN_TEXT",
    HR_HORSE_EIGHTEEN_BACKGROUND = "$FP_HR_HORSE_EIGHTEEN_BACKGROUND",
    HR_HORSE_EIGHTEEN_TEXT = "$FP_HR_HORSE_EIGHTEEN_TEXT",
    HR_HORSE_NINETEEN_BACKGROUND = "$FP_HR_HORSE_NINETEEN_BACKGROUND",
    HR_HORSE_NINETEEN_TEXT = "$FP_HR_HORSE_NINETEEN_TEXT",
    HR_HORSE_TWENTY_BACKGROUND = "$FP_HR_HORSE_TWENTY_BACKGROUND",
    HR_HORSE_TWENTY_TEXT = "$FP_HR_HORSE_TWENTY_TEXT",
    HR_HORSE_TWENTY_ONE_BACKGROUND = "$FP_HR_HORSE_TWENTY_ONE_BACKGROUND",
    HR_HORSE_TWENTY_ONE_TEXT = "$FP_HR_HORSE_TWENTY_ONE_TEXT",
}

export const Transition = (property = "all", duration = 0.3): { transition: string } => {
    return { transition: `ease ${property} ${duration}s` };
};
